module.exports = __webpack_public_path__ + "static/media/electric-ireland.cc04f4de.png";